import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { API_BASE } from "../const/config";
import jwt from "jwt-encode";

let prevNonceTs = 0;
const getNonceTs = () => {
  let nonceTs = Date.now();
  if (nonceTs === prevNonceTs) {
    nonceTs = nonceTs + 1;
  }
  prevNonceTs = nonceTs;
  return nonceTs;
};

export const staticAuthFetch = (
  config: AxiosRequestConfig<any>,
  publicKey?: string,
  secretKey?: string
) => {
  if (!config.headers) {
    config.headers = {};
  }
  config.headers["Accept"] = "application/json";
  config.url = "/auth" + config.url;

  if (publicKey && secretKey) {
    var token = jwt(
      { public_key: publicKey, path: config.url, nonce_ts: getNonceTs() },
      secretKey
    );
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return staticFetch(config);
};

export function staticFetch<T = any>(
  config: AxiosRequestConfig<any>
): Promise<AxiosResponse<T>> {
  if (!config.headers) {
    config.headers = {};
  }
  config.headers["Accept"] = "application/json";
  if (!config.url || !config.url.startsWith("http")) {
    config.url = API_BASE + config.url;
  }
  config.withCredentials = true;
  return axios(config);
}
